import { ProcedureKey } from "../../data/procedures";

export interface ProcedureSlice {
  // State
  currentProcedure: ProcedureKey;

  // Actions
  setProcedure: (procedure: ProcedureKey) => void;
}

export const createProcedureSlice = (set: any): ProcedureSlice => ({
  // Initial state
  currentProcedure: ProcedureKey.LIFTING,

  // Actions
  setProcedure: (procedure: ProcedureKey) =>
    set({ currentProcedure: procedure }),
});
